import styled from "@emotion/styled";
import {IndicatorColors} from "./ColorizedIndicators";
import ColorizedIndicatorsGridRow from "./ColorizedIndicatorsGridRow";
import ColorizedIndicatorsHeader from "./ColorizedIndicatorsHeader";
import {Collapse} from "@blueprintjs/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {IndicatorLogicType, UserColor} from "./types/indicatorLogicType";
import {DragIcon} from "../../../common/icons";

type ColorizedIndicatorItemProps = {
  color: UserColor;
  logics: IndicatorLogicType[];
  isExpanded: boolean;
  onToggleCollapse: (color: UserColor) => void;
  onEdit: (logic: IndicatorLogicType) => void;
  dragProps: any;
};

type CollapseColorTagProps = {
  color: string;
};

const ColorizedIndicatorItem = ({
  color,
  logics,
  isExpanded,
  onToggleCollapse,
  onEdit,
  dragProps
}: ColorizedIndicatorItemProps) => {
  return (
    <ColorizedIndicatorItemContainer data-testid="color-logic-item">
      <CollapseContainer>
        <HeaderItemContainer>
          <CollapseColorTag color={IndicatorColors[color].hex} />
          <DragIcon data-testid="color-logic-item-drag" {...dragProps}></DragIcon>
          <Text>Rank #{logics[0].rank}</Text>
        </HeaderItemContainer>
        <HeaderItemContainer>
          <div>
            <ColorNameHeaderText>{IndicatorColors[color].name}</ColorNameHeaderText> ({logics.length})
          </div>
          <CollapseButton onClick={() => onToggleCollapse(color)} data-testid="color-logic-item-collapse">
            <FontAwesomeIcon
              icon={isExpanded ? solid("chevron-up") : solid("chevron-down")}
              size="xs"
              color="#161616"
            />
          </CollapseButton>
        </HeaderItemContainer>
      </CollapseContainer>
      {logics.map((logic) => {
        return (
          <Collapse isOpen={isExpanded} key={`${logic.key}`}>
            <ColorizedIndicatorsGrid>
              <ColorizedIndicatorsHeader />
              <ColorizedIndicatorsGridRow logic={logic} onEditLogicHandler={onEdit} />
            </ColorizedIndicatorsGrid>
          </Collapse>
        );
      })}
    </ColorizedIndicatorItemContainer>
  );
};

export default ColorizedIndicatorItem;

const ColorizedIndicatorItemContainer = styled.div`
  margin-bottom: 1px;
`;

const CollapseColorTag = styled.div<CollapseColorTagProps>`
  display: inline-flex;
  width: 7px;
  height: 39px;
  background-color: ${(props) => props.color};
  border-radius: 2px;
`;

const ColorizedIndicatorsGrid = styled.div`
  display: grid;
  grid:
    [row1-start] "header header header header header header" 1fr [row1-end]
    / 30px minmax(80px, 0.2fr) 1fr minmax(110px, 0.4fr) 0.2fr 50px;
`;

const CollapseContainer = styled.div`
  background-color: white;
  box-shadow: 0px 5px 6px 0px #00000040;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 2px;
`;
const HeaderItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 14px;
`;
const Text = styled.span`
  margin-left: 10px;
  color: #797979;
`;

const ColorNameHeaderText = styled(Text)`
  color: #161616;
  font-weight: 500;
`;

const CollapseButton = styled.div`
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  cursor: pointer;
`;
